/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for `FilterItem` items.
 * @export
 * @interface FilterItem
 */
export interface FilterItem {
    /**
     * 
     * @type {number}
     * @memberof FilterItem
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FilterItem
     */
    name: string;
}

/**
 * Check if a given object implements the FilterItem interface.
 */
export function instanceOfFilterItem(value: object): value is FilterItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FilterItemFromJSON(json: any): FilterItem {
    return FilterItemFromJSONTyped(json, false);
}

export function FilterItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FilterItemToJSON(json: any): FilterItem {
    return FilterItemToJSONTyped(json, false);
}

export function FilterItemToJSONTyped(value?: Omit<FilterItem, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

